import { render, staticRenderFns } from "./UserNotificationCard.vue?vue&type=template&id=75e3d0e2&"
import script from "./UserNotificationCard.vue?vue&type=script&lang=js&"
export * from "./UserNotificationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports